module.exports = __webpack_public_path__ + "fonts/Chivo-Regular.dd17e11.ttf";